import { render } from "./EspecialidadesEstados.vue?vue&type=template&id=78556836"
const script = {}

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__